// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"BRNSXGJ7RkInUIH8_NqI","dateRangePlaceholder":"bYJ2LoLsoqv3tpdUnUeF"};